import React from "react";
import EndingBody from "../../../components/customer/LandingCustomer/EndingBody";
import EndingFooter from "../../../components/customer/LandingCustomer/EndingFooter";
import Header from "../../../components/customer/ProductsCustomer/Header";
import {useMediaQuery} from "react-responsive";
import HeaderMobile from "../../../components/customer/ProductsCustomer/Mobile/HeaderMobile";
import EndingBodyMobile from "../../../components/customer/LandingCustomer/Mobile/EndingBodyMobile";
import EndingFooterMobile from "../../../components/customer/LandingCustomer/Mobile/EndingFooterMobile";

const EndingCustomer = () => {

    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 480px)",

    });

    return (
        <React.Fragment>
            <div
                style={{width: "100%", height: '100%', backgroundColor: "#F5F6F9"}}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    {isMobileDevice ? <HeaderMobile/> : <Header/>}
                </div>

                {isMobileDevice
                    ?
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "#9FCDE7",
                            paddingTop: "80px",
                            paddingBottom: "80px",
                            width: "100%",
                            justifyContent: "center"
                        }}
                    >
                        <EndingBodyMobile/>
                    </div>

                    :
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "#9FCDE7",
                            height: "650px",
                            width: "100%",
                            justifyContent: "center"
                        }}
                    >
                        <EndingBody/>
                    </div>
                }

                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        height:'400px',
                        // bottom:0
                    }}
                >
                    {isMobileDevice ? <EndingFooterMobile/> : <EndingFooter/>}
                </div>
            </div>
        </React.Fragment>
    );
};

export default EndingCustomer;
